export default {
  // Global styling -----------

  global: {
    fontSizes: {
      body: 2,
    },
    body: {
      fontFamily: 'body',
      fontWeight: 'body',
    },
    p: { fontSize: 'body' },
    'h1, h2, h3, h4, h5, h6': {
      fontFamily: 'heading',
      fontWeight: 'heading',
      color: 'inherit',
    },
    // Workaround for dynamically styling Bootstrap components.
    // This might cause specificity issues
    // because the styles are always scoped with the 'root' component,
    // so we have to take care applying only the most important styles as needed.
    '.btn-primary': {
      backgroundColor: 'primary',
      borderColor: 'primary',
      ':hover': { backgroundColor: 'primaryHover' },
    },
    a: { color: 'primary', ':hover': { color: 'primaryHover' } },
    '.btn-outline-secondary': {
      borderColor: '#f3f3f3',
    },
  },

  pre: {
    variant: `prism`,
    fontFamily: `monospace`,
    tabSize: 4,
    hyphens: `none`,
    marginBottom: 0,
    color: `white`,
    bg: `prism.background`,
    overflow: `auto`,
    borderRadius: 10,
    p: 3,
  },
  code: {
    fontFamily: `monospace`,
    // from typography overrideThemeStyles
    // "h1 code, h2 code, h3 code, h4 code, h5 code, h6 code"
    fontSize: `inherit`,
  },
  inlineCode: {
    borderRadius: `0.3em`,
    color: `secondary`,
    bg: `highlight`,
    paddingTop: `0.15em`,
    paddingBottom: `0.05em`,
    paddingX: `0.2em`,
  },
  // from typography overrideThemeStyles
  a: {
    color: `primary`,
  },
  hr: {
    borderColor: `muted`,
  },
  p: {
    code: {
      fontSize: `inherit`,
    },
  },
  li: {
    code: {
      fontSize: `inherit`,
    },
  },
  blockquote: {
    color: `inherit`,
    borderLeftColor: `inherit`,
    opacity: 0.8,
    '&.translation': {
      fontSize: `1em`,
    },
  },
};
